import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { auleloApi, auleloAuth } from "@/lib/auleloApi";
import { Loader2, ShieldCheck } from "lucide-react";
import AuleloLogin from "@/pages/aulelo/AuleloLogin";

/** Catches /:secret and tries to auth with the slug as passkey.
 * If the slug == current passkey → auto-login and redirect to console.
 * If not → render AuleloLogin (so admin can type correct passkey manually).
 * Any non-slug-shaped path (e.g. /admin, /login) is excluded by App router order.
 */
export default function AuleloGate() {
  const { secret = "" } = useParams();
  const nav = useNavigate();
  const [phase, setPhase] = useState("checking");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      // If already authed, skip
      if (auleloAuth.getToken()) {
        try {
          const { data } = await auleloApi.get("/me");
          if (data.first_login) nav("/aulelo/first-login", { replace: true });
          else nav("/aulelo/console", { replace: true });
          return;
        } catch {
          auleloAuth.clear();
        }
      }
      try {
        const { data } = await auleloApi.post("/auth", { passkey: secret });
        if (cancelled) return;
        auleloAuth.saveToken(data.token);
        if (data.first_login) nav("/aulelo/first-login", { replace: true });
        else nav("/aulelo/console", { replace: true });
      } catch {
        if (!cancelled) setPhase("manual");
      }
    })();
    return () => { cancelled = true; };
  }, [secret, nav]);

  if (phase === "checking") {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="flex items-center gap-3 text-emerald-400 font-mono uppercase tracking-widest text-xs">
          <ShieldCheck className="w-4 h-4 animate-pulse" />
          <Loader2 className="w-4 h-4 animate-spin" />
          establishing channel…
        </div>
      </div>
    );
  }
  return <AuleloLogin />;
}
